export const mobileSize = 768;
export const tabletSize = 1024;
